import { numericExtent, temaSeries } from "../utils";
const TEMA = {
    name: "TEMA",
    compute: (bars, period = 9) => temaSeries(bars.map((b) => b.close), period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default TEMA;
